<script>
import { mapGetters } from "vuex";
import Choice from "@/components/Choice";

export default {
  name: "QuizPage",
  components: {
    Choice
  },
  data: () => ({
    showButton: false,
    showAnswerMsg: false,
    isPlaying: false
  }),
  mounted() {
      this.$store.dispatch('startStation');
      document.addEventListener('click', this.countClick);
  },
  methods: {
    buttonClicked() {
      this.scrollToTop();
      this.$store.dispatch('switchScreen', 'spectro');
    },
    choiceHandler(isPlaying, correctChoice) {
      this.isPlaying = isPlaying;

      if (this.showButton)
        return;
        
      if (!isPlaying && correctChoice === false) {
        this.showAnswerMsg = true;
      } 
      else if (!isPlaying && correctChoice) {
        this.showButton = true;
      }
      else {
        this.showAnswerMsg = false;
        this.showButton = false;
      }
    },
    countClick() {
      if (!this.stationEnd)
        this.$store.dispatch('clickCount');
    },
    scrollToTop() {
      if (document.getElementsByClassName('station-content').length > 0)
        document.getElementsByClassName('station-content')[0].scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    },
  },
  computed: {
    ...mapGetters({
      instruction: 'getCurrentInstruction',
      verses: 'getCurrentVerses',
      voiceOver: 'getCurrentVoiceover',
      answerMsg: 'getQuizAnswerMessage'
    })
  },
  destroyed() {
    document.removeEventListener('click', this.countClick);
  }
};
</script>

<template>
  <div class="quiz">
    <div class="quiz__content">
      <p class="quiz__instruction">{{instruction}}</p>
      <Choice
        v-for="(item, index) in verses"
        :key="index"
        v-bind:audioSrc="item.verse"
        v-bind:title="item.title"
        v-bind:correctChoice="item.correct_choice"
        v-bind:answerSrc="item.answer"
        v-bind:isEnabled="!isPlaying"
        v-on:isVoiceOver="choiceHandler"
      />
    </div>
    <div class="quiz__actions">
      <transition name="button-transition">
        <p class="quiz__message" v-if="showAnswerMsg">{{answerMsg}}</p>
      </transition>
      <transition name="button-transition">
        <button v-if="showButton" class="common-button" v-on:click="buttonClicked">{{$t('quiz.next')}}</button>
      </transition>
    </div>
    <transition name="fade">
      <div class="quiz__click-disabler" v-if="isPlaying"></div>
    </transition>
  </div>
</template>

<style scoped>
.quiz {
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 calc(var(--gutter) * 3);
}
.quiz__instruction {
  font-size: 2rem;
  line-height: 1.34;
  max-width: 36rem;
  margin: 3rem 0 3rem;
}
.quiz__actions {
  margin-top: 5rem;
}
.quiz__message {
  margin: 0 0 3rem;
  font-size: 1.5rem;
  text-align: center;
}
.quiz__click-disabler {
  position: fixed;
  top: calc(var(--bezel) * 1.75); left: 0;
  width: 100%; height: 100%;
  background: var(--light);
  opacity: .5;
  z-index: 10;
}
.button-transition-enter-active {
  transform-origin: 50% 300%;
  transition: 100ms opacity linear 600ms, 666ms transform cubic-bezier(.8,.3,.25,1.66) 450ms;
}
.button-transition-enter {
  opacity: 0;
  transform: translate3d(0, 0, 20rem) rotateX(-80deg) skewY(-10deg);
}
.button-transition-leave-active {
  transition: 100ms opacity linear 0ms;
}
.button-transition-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: 500ms opacity linear 100ms;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>